import {ReactElement} from "react";
import {useNewDesignEnabled} from "~/new-design/hooks";

type NewDesignGateProps = {
  newDesign: ReactElement;
  legacy: ReactElement;
};

export const NewDesignGate = ({newDesign, legacy}: NewDesignGateProps) => {
  const isNewDesign = useNewDesignEnabled();
  return isNewDesign ? newDesign : legacy;
};
